//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters, mapMutations } from "vuex";
import { ethers, utils, Wallet } from "ethers";
import store from "@/store";

import AWalletHelpers from "@/assets/js/AWalletHelpers";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import { CustomJsonRpcProvider } from "./EthersExtenstion";
import AQInput from "../AQInput/AQInput.vue";
import AWalletImport from "./AWalletImport.vue";

export default {
    components: {
        AQInput,
        AWalletImport,
        AQModal
    },
    props: {
        objectContractMapping: {
            type: Object,
            default: () => {}
        },
        openSign: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            provider: null,
            localWallets: [],
            selectedWalletIndex: null,
            password: "",
            decryptedWallet: null,
            isDecrypting: false,
            errors: {
                password: {
                    active: false,
                    text: this.$t("wallet.error.invalidPassword")
                }
            },
            openWalletSign: false,
            network: null,
            contract: {},
            validateWallet: false,
            stopDecrypting: true,
            readOnlyState: false
        };
    },
    computed: {
        ...mapGetters({
            getSelectedAccount: "aWallet/getSelectedAccount",
            getSaveForLater: "aWallet/getSaveForLater",
            getCtaDisabled: "aWallet/getCtaDisabled",
            getLoading: "aWallet/getLoading",
            getUserId: "userProfile/getUserId"
        }),
        isCall() {
            const { methodType } = this.objectContractMapping || {};
            return methodType === "call";
        },
        saveButton() {
            return {
                label: this.$t("wallet.cta.sign"),
                disabled: this.readOnlyState || this.getCtaDisabled,
                isLoading: this.isLoading
            };
        },
        selectedAccount() {
            return this.getSelectedAccount;
        },
        isSmallScreen() {
            return !!localStorage.getItem("localIsSmallScreen");
        }
    },
    watch: {
        openSign: {
            handler(newValue) {
                this.openWalletSign = newValue;
                if (newValue) {
                    this.getData();
                }
            }
        },
        wallets: {
            handler(newValue) {
                this.localWallets = newValue;
            }
        }
    },

    created() {
        this.setSelectedAccount(null);
        this.setSaveForLater(false);
    },
    activated() {
        this.setSelectedAccount(this.decryptedWallet);
    },
    destroyed() {
        this.setSelectedAccount(null);
        this.$root.$off("wallet-sign");
    },
    methods: {
        ...mapMutations({
            setIsLoading: "aWallet/setIsLoading",
            setCtaDisabled: "aWallet/setCtaDisabled",
            setSelectedAccount: "aWallet/setSelectedAccount",
            setSaveForLater: "aWallet/setSaveForLater"
        }),
        ...mapActions("userProfile", ["getUserDetails"]),
        $_signTransaction() {
            this.contract = this.objectContractMapping;
            this.network = this.contract.network || "";
            this.provider = new CustomJsonRpcProvider({ url: this.network });

            if (this.isCall && !this.contract.isCallId) {
                this.signTransaction(null);
            } else {
                this.getData().then(() => {
                    if (sessionStorage.getItem("wallet")) {
                        const { wallet, privateKey } = JSON.parse(sessionStorage.getItem("wallet"));

                        wallet.wallets[0] = new ethers.Wallet(privateKey);
                        for (let i = 0; i < this.localWallets.length; i++) {
                            if (this.localWallets[i].id === wallet.id) {
                                this.selectedWalletIndex = i;
                                this.localWallets[i] = wallet;
                                this.setCtaDisabled(false);
                            }
                        }
                        this.selectAccount(0);
                    }

                    this.openWalletSign = true;
                });
            }
        },
        loadingKeystore(event) {
            this.isDecrypting = event;
        },
        checkAccountName(walletIdx) {
            return this.localWallets[walletIdx].accounts[0].name;
        },
        getData() {
            return new Promise((resolve) => {
                if (!this.getUserId) {
                    store()
                        .dispatch("tasks/getUserDetails")
                        .then((data) => {
                            if (data) {
                                const { id } = data;
                                AWalletHelpers.getAllWallets(id).then((wallet) => {
                                    this.localWallets = wallet;
                                    resolve(true);
                                });
                            }
                        });
                } else {
                    AWalletHelpers.getAllWallets(this.getUserId).then((wallet) => {
                        this.localWallets = wallet;
                        resolve(true);
                    });
                }
            });
        },
        singModalAction(action) {
            if (action === "close") {
                if (this.isDecrypting) {
                    this.validateWallet = false;
                    this.isDecrypting = false;
                }
                this.selectedWalletIndex = null;
                this.openWalletSign = false;
                this.$emit("cancelSign", false);
            }
            if (action === "primary") {
                if (this.getSaveForLater) {
                    this.$root.$emit("wallet-import");
                    this.isDecrypting = false;
                    return;
                }
                this.signTransaction(this.selectedAccount);
            }
        },
        onImportSuccess(decryptedWallet) {
            this.selectedWalletIndex = this.localWallets && this.localWallets.length ? this.localWallets.length - 1 : 0;
            this.localWallets[this.selectedWalletIndex].wallets = [];
            this.localWallets[this.selectedWalletIndex].wallets.push(decryptedWallet);
            const wallet = {
                privateKey: this.localWallets[this.selectedWalletIndex].wallets[0].privateKey,
                wallet: this.localWallets[this.selectedWalletIndex]
            };
            sessionStorage.setItem("wallet", JSON.stringify(wallet));
            this.setSaveForLater(false);
            this.signTransaction(this.selectedAccount);
        },
        otherWalletSelected() {
            this.selectedWalletIndex = null;
        },
        checkSelectWallet($event) {
            this.validateWallet = $event;
        },
        async decryptWallet(encryptedWallet) {
            this.validateWallet = true;
            this.isDecrypting = true;
            this.localWallets[this.selectedWalletIndex].wallets = [];
            this.stopDecrypting = true;
            if (encryptedWallet.type === "hd") {
                try {
                    const data = await AWalletHelpers.getWallet(encryptedWallet.id, this.password);
                    const mnemonic = data.decryptedData;
                    const passphrase = data.decryptedPassphrase;

                    for (let i = 0; i < encryptedWallet.accounts.length; i++) {
                        const path = `m/44'/60'/0'/0/${i}`;
                        const hdNode = utils.HDNode.fromMnemonic(mnemonic, passphrase).derivePath(path);
                        const wallet = new Wallet(hdNode.privateKey);

                        this.localWallets[this.selectedWalletIndex].wallets.push(wallet);
                    }
                    this.setCtaDisabled(false);
                    sessionStorage.removeItem("wallet");
                    this.selectAccount(0);
                } catch (e) {
                    this.errors.password.active = true;
                } finally {
                    this.isDecrypting = false;
                }
            }

            if (encryptedWallet.type === "privateKey") {
                try {
                    const privateKey = (await AWalletHelpers.getWallet(encryptedWallet.id, this.password)).decryptedData;
                    const wallet = new ethers.Wallet(privateKey);
                    this.localWallets[this.selectedWalletIndex].wallets.push(wallet);
                    this.setCtaDisabled(false);
                    sessionStorage.removeItem("wallet");
                    this.selectAccount(0);
                } catch (e) {
                    this.errors.password.active = true;
                } finally {
                    this.isDecrypting = false;
                }
            }

            if (encryptedWallet.type === "keystoreFile") {
                try {
                    const json = AWalletHelpers.getKeystore(encryptedWallet.id);
                    const wallet = await ethers.Wallet.fromEncryptedJson(json, this.password);

                    if (this.stopDecrypting) {
                        this.localWallets[this.selectedWalletIndex].wallets.push(wallet);
                        this.setCtaDisabled(false);
                        sessionStorage.removeItem("wallet");
                        this.selectAccount(0);
                    }
                } catch (e) {
                    this.errors.password.active = true;
                } finally {
                    this.isDecrypting = false;
                }
            }
            this.validateWallet = false;
        },
        async signTransaction(wallet) {
            this.setIsLoading(true);
            if (!this.isCall) {
                this.readOnlyState = true;
            }

            try {
                const signer = this.contract.methodType === "transaction" || this.contract.isCallId ? wallet.connect(this.provider) : this.provider;
                const contract = new ethers.Contract(this.contract.contract.address, this.contract.contract.abi, signer);
                const payload = [];
                let callProps = { gasPrice: 0, gasLimit: 7000000000 };
                if (this.contract.requestResult && Object.keys(this.contract.requestResult).length) {
                    if (this.contract._request.active) {
                        if (this.contract.requestResult.__options) {
                            callProps = Object.keys(this.contract.requestResult.__options).length === 0 ? null : this.contract.requestResult.__options;
                            delete this.contract.requestResult.__options;
                        }
                        payload.push(...Object.values(this.contract.requestResult));
                    } else {
                        const formattedReq = this.bcRequestFormatter(this.contract.dataFromContract, this.contract.requestResult, this.contract.method);
                        payload.push(...Object.values(formattedReq));
                    }
                }
                // if (this.networkType === "quorum") {
                if (callProps) {
                    payload.push(callProps);
                }
                // }
                const example = await contract[this.contract.method](...payload);
                if (!this.isCall) {
                    this.$toast.showNotify({
                        message: this.$t("wallet.dashboard.notifyMessage"),
                        caption: this.$t("wallet.dashboard.captionMessage"),
                        timeout: 3000
                    });
                }

                let result;

                if (this.isCall) {
                    result = example;
                    // mapare response
                    this.$emit("sign-transaction-success", this.contract, result);
                } else {
                    result = await example.wait();
                    if (result.status) {
                        this.openWalletSign = false;
                        this.$emit("action", "close");
                        this.$emit("refresh-wallet-list");
                        this.$emit("sign-transaction-success", this.contract, null);
                    } else {
                        const err = `status: ${result.status}, txhash: ${result.transactionHash}`;
                        throw new Error(err);
                    }
                }
                this.$toast.showNotify({
                    message: this.isCall ? this.$t("wallet.callSuccess") : this.$t("wallet.signSuccess"),
                    type: "success"
                });
            } catch (e) {
                console.log("error", e);
                this.$root.$emit("sign-transaction-fail", e);
                this.$toast.showNotify({
                    message: this.isCall ? this.$t("wallet.callFail") : this.$t("wallet.signFail"),
                    type: "error"
                });
            } finally {
                this.setIsLoading(false);
                this.readOnlyState = false;
            }
        },
        bcTypeFormatter(value, type) {
            switch (type) {
                case "string":
                    return String(value);
                case "integer":
                    return typeof value === "number" ? value : ethers.BigNumber.from(value);
                case "boolean":
                    return !!value;
                default:
                    return value;
            }
        },

        addBcValueToPath(path, value, formattedResponse) {
            const paths = path.split(".");
            let aux = formattedResponse;
            for (let i = 0; i < paths.length; i++) {
                if (i === paths.length - 1) {
                    aux[paths[i]] = value;
                } else {
                    if (!aux[paths[i]]) {
                        aux[paths[i]] = {};
                    }
                    aux = aux[paths[i]];
                }
            }
        },

        bcFieldsFormatter(fields, requestObject, formatedResponse = {}) {
            fields.forEach((v) => {
                this.addBcValueToPath(v.path, undefined, formatedResponse);
                let formattedField;
                if (v.type === "object") {
                    if (v.isList) {
                        formattedField = [];
                        v.fields.forEach((f) => {
                            const requestFieldsArr = requestObject[f.path];
                            const fieldName = f.name;
                            if (requestFieldsArr) {
                                requestFieldsArr.forEach((fv, i) => {
                                    if (!formattedField[i]) {
                                        formattedField[i] = {};
                                    }

                                    formattedField[i][fieldName] = fv;
                                });
                            }
                        });
                        this.addBcValueToPath(v.path, formattedField, formatedResponse);
                    } else {
                        this.bcFieldsFormatter(v.fields, requestObject, formatedResponse);
                    }
                } else {
                    if (v.isList) {
                        formattedField = requestObject[v.path].map((rv) => this.bcTypeFormatter(rv, v.type));
                    } else {
                        formattedField = this.bcTypeFormatter(requestObject[v.path], v.type);
                    }
                    this.addBcValueToPath(v.path, formattedField, formatedResponse);
                }
            });
            return formatedResponse;
        },

        bcRequestFormatter(parsedAbi, requestObject, methodName) {
            const method = parsedAbi.filter((v) => v.name === methodName)[0];
            return this.bcFieldsFormatter(method.inputs, requestObject);
        },
        selectAccount(index) {
            const { wallets } = this.localWallets[this.selectedWalletIndex];

            if (!wallets) {
                return;
            }
            // save account in session storage
            this.setSelectedAccount(wallets[index]);
            if (!sessionStorage.getItem("wallet")) {
                const wallet = {
                    privateKey: this.localWallets[this.selectedWalletIndex].wallets[0].privateKey,
                    wallet: this.localWallets[this.selectedWalletIndex]
                };
                sessionStorage.setItem("wallet", JSON.stringify(wallet));
            }
        },
        checkIfDecrypt() {
            const { wallet, privateKey } = JSON.parse(sessionStorage.getItem("wallet"));
            const walletToSign = new ethers.Wallet(privateKey);
            let existWallet = false;
            this.localWallets[this.selectedWalletIndex].wallets = walletToSign;
            if (this.localWallets[this.selectedWalletIndex].id === wallet.id) {
                this.localWallets[this.selectedWalletIndex] = wallet;
                this.setSelectedAccount(walletToSign);
                this.setCtaDisabled(false);
                existWallet = true;
            }
            return existWallet;
        },
        walletChange() {
            this.password = null;
            let isExist = false;
            this.errors.password.active = false;
            this.stopDecrypting = false;
            if (sessionStorage.getItem("wallet")) {
                isExist = this.checkIfDecrypt();
            }
            if (!isExist) {
                this.setSelectedAccount(null);
                this.setCtaDisabled(true);
            }
        }
    }
};
